<template>
  <base-page>
    <el-card style="margin: 5px 0px 5px 0px">
      <el-collapse accordion style="border: none">
        <el-collapse-item name="1" style="border: none">
          <template slot="title">
            <div slot="header" class="clearfix">
              <titlu-pagina Titlu="Devize finalizate" @on_add_clicked="show_dialog()" :AdaugaVisible="false" />
            </div>
          </template>
          <div class="filtre">
            <el-form @submit.prevent.native="refresh_info()">
              <el-row style="margin: 10px" class="input-group">
                <el-col class="input-element">
                  <el-form-item label='Interval' size="mini">
                    <el-date-picker size="mini" v-model="Filters.Data" type="daterange" range-separator="-"
                      start-placeholder="Data inceput" end-placeholder="Data sfarsit"
                      :picker-options="datePickerOptions" format="dd/MM/yyyy" value-format="yyyy-MM-dd">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label="Numar inmatriculare" size="mini">
                    <el-input v-model="Filters.Numar" />
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label="Marca" size="mini" class='full-width'>
                    <el-select v-model="Filters.Marca" @change="marcaChangeHandler()" class="full-width" filterable
                      size="mini" clearable>
                      <el-option label="Toate" value="-1" />
                      <el-option v-for="item in Info.marci" :key="'marci' + item.Id" :label="item.Nume"
                        :value="item.Id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label="Model" size="mini" class='full-width'>
                    <el-select v-model="Filters.Model" @change="refresh_info" class="full-width" filterable size="mini"
                      clearable :disabled="Filters.Marca == -1 || Filters.Marca == '' || !Filters.Marca">
                      <el-option label="Toate" value="-1" />
                      <el-option v-for="item in Info.modele" :key="'modele' + item.Id" :label="item.Nume"
                        :value="item.Id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col class="input-element">
                  <el-form-item label="Tip auto" size="mini">
                    <el-select v-model="Filters.TipAuto" class="full-width">
                      <el-option label="Toate" value="-1"></el-option>
                      <el-option label="Normal" value="Normal"></el-option>
                      <el-option label="SUV" value="SUV"></el-option>
                      <el-option label="Autoutilitar" value="Autoutilitar"></el-option>
                      <el-option label="Supercar" value="Supercar"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label="Nume client" size="mini">
                    <el-input v-model="Filters.Client" />
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label="Numar deviz" size="mini">
                    <el-input v-model="Filters.IdDeviz" clearable />
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label='Centru productie' size="mini">
                    <el-select class='full-width' v-model='Filters.IdCentruProductie' filterable>
                      <el-option label='Toate' value='-1'></el-option>
                      <el-option v-for='item in Info.centre_productie' :key="'centre_productie' + item.Id"
                        :label='item.Nume' :value='item.Id' />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label='Serviciu programator' size="mini">
                    <el-select class='full-width' v-model='Filters.IdServiciuProgramator' filterable>
                      <el-option label='Toate' value='-1'></el-option>
                      <el-option v-for='item in Info.servicii_programator' :key="'serviciu_programator' + item.Id"
                        :label='item.Nume' :value='item.Id' />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label="Antifurt" size="mini">
                    <el-select v-model="Filters.Antifurt" class="full-width">
                      <el-option label="Toate" value="-1" />
                      <el-option label="Da" value="1" />
                      <el-option label="Nu" value="0" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label="Valoare Min" size="mini">
                    <el-input-number v-model="Filters.ValoareMin" :precision="0" :max="999999" :min="0" />
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label="Valoare Max" size="mini">
                    <el-input-number v-model="Filters.ValoareMax" :precision="0" :max="999999" :min="0" />
                  </el-form-item>
                </el-col>
                <el-col :md="24">
                  <el-button type="primary" size="small" native-type="submit" @click="refresh_info()">
                    Aplica
                  </el-button>
                  <el-button type="danger" native-type="submit" @click="reset()" size="small">
                    Reseteaza
                  </el-button>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-card>

    <el-table el-table :data="Results">
      <el-table-column prop="Id" label="#" width="80px" />
      <el-table-column prop="DataDeschiderii" label="Data consimtamant"></el-table-column>
      <el-table-column label="Data preluare">
        <template slot-scope="scope">
          {{ formatDate(scope.row.DataPreluareInLucru) ? formatDate(scope.row.DataPreluareInLucru) : '-' }}
        </template>
      </el-table-column>
      <el-table-column label="Data aprobare">
        <template slot-scope="scope">
          {{ formatDate(scope.row.DataAprobare) ? formatDate(scope.row.DataAprobare) : '-' }}
        </template>
      </el-table-column>
      <el-table-column label="Data facturare">
        <template slot-scope="scope">
          {{ formatDate(scope.row.DataFacturare) ? formatDate(scope.row.DataFacturare) : '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="Numar" label="Numar"></el-table-column>
      <el-table-column prop="NumeClient" label="Client"></el-table-column>
      <el-table-column prop="ValoareDeviz" label="Valoare"></el-table-column>
      <el-table-column prop="Antifurt" label="Antifurt">
        <template slot-scope="scope">
          {{ scope.row.Antifurt == 0 ? "Nu" : "Da" }}
        </template>
      </el-table-column>
      <el-table-column prop="Penalizat" label="Penalizat">
        <template slot-scope="scope">
          {{ scope.row.Penalizat == 0 ? "Nu" : "Da" }}
        </template>
      </el-table-column>
      <el-table-column v-if="device === 'computer'" align="right" fixed="right" label="Actiuni" width="240px">
        <template slot-scope="scope">
          <el-tooltip content="Penalizeaza deviz">
            <el-button type="danger" size="mini" icon="el-icon-warning" circle @click="open_penalizare(scope.row)" />
          </el-tooltip>
          <el-tooltip content="Print consimtamant">
            <el-button size="mini" icon="el-icon-printer" circle @click="print_consimtamant(scope.row.Id)" />
          </el-tooltip>
          <el-tooltip content="Preview">
            <el-button type="primary" size="mini" icon="el-icon-view" circle @click="preview(scope.row.Id)" />
          </el-tooltip>
          <el-tooltip content="Adauga programare noua">
            <el-button size="mini" type="success" icon="el-icon-plus" circle @click="adauga_programarea(scope.row)" />
          </el-tooltip>
          <el-tooltip content="Print deviz">
            <el-button type="info" size="mini" icon="el-icon-printer" circle @click="print_deviz(scope.row.Id)" />
          </el-tooltip>
          <el-tooltip content="Print inspectie">
            <el-button type="warning" size="mini" icon="el-icon-printer" circle
              @click="print_inspectie(scope.row.Id)" />
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column v-else fixed="right" label="Actiuni" width="70px" type="expand">
        <template slot-scope="scope">
          <div class="phone-btn">
            <el-tooltip content="Penalizeaza deviz">
              <el-button type="danger" size="mini" icon="el-icon-warning" circle @click="open_penalizare(scope.row)" />
            </el-tooltip>
            <el-tooltip content="Print consimtamant">
              <el-button size="mini" icon="el-icon-printer" circle @click="print_consimtamant(scope.row.Id)" />
            </el-tooltip>
            <el-tooltip content="Preview">
              <el-button type="primary" size="mini" icon="el-icon-view" circle @click="preview(scope.row.Id)" />
            </el-tooltip>
            <el-tooltip content="Adauga programare noua">
              <el-button size="mini" type="success" icon="el-icon-plus" circle @click="adauga_programarea(scope.row)" />
            </el-tooltip>
            <el-tooltip content="Print deviz">
              <el-button type="info" size="mini" icon="el-icon-printer" circle @click="print_deviz(scope.row.Id)" />
            </el-tooltip>
            <el-tooltip content="Print inspectie">
              <el-button type="warning" size="mini" icon="el-icon-printer" circle
                @click="print_inspectie(scope.row.Id)" />
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination @size-change="refresh_info" @current-change="refresh_info" :page-size.sync="PaginationInfo.PerPage"
      :current-page.sync="PaginationInfo.Page" :total="PaginationInfo.RowCount" layout="pager" />
    <Previewdeviz ref="preview_deviz" />
    <Rezervari-dialog v-show="false" ref="dlg_rez" @save="refresh_info()" />
    <penalizare-dialog ref="dlg_penalizare" @saved="refresh_info()" />
  </base-page>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";
import TitluPagina from "@/widgets/TitluPagina";
import Previewdeviz from '@/components/Preview_deviz';
import Rezervari_dialog from "@/pages/Receptie/Rezervari_list.vue";
import PenalizareDialog from "../../components/PenalizareDialog.vue";
import LocalSettings from "../../backend/LocalSettings";

export default {
  name: "masini",
  extends: BasePage,
  components: {
    "base-page": BasePage,
    "titlu-pagina": TitluPagina,
    "Rezervari-dialog": Rezervari_dialog,
    Previewdeviz,
    'penalizare-dialog': PenalizareDialog,
  },
  data() {
    return {
      datePickerOptions: settings.datePickerOptions,
      device: "",
      Results: [],
      base_url: "",
      Info: {
        clienti: [],
        marci: [],
        modele: [],
      },
      Filters: {
        Data: [],
        Numar: "",
        Marca: "-1",
        Model: "-1",
        TipAuto: "-1",
        Client: "",
        IdDeviz: "",
        IdCentruProductie: "-1",
        IdServiciuProgramator: "-1",
        Antifurt: "-1",
        ValoareMin: "",
        ValoareMax: "",
      },
      OrderBy: {},
      PaginationInfo: {
        Page: 1,
        PerPage: 50,
        RowCount: 0,
        PageSizes: [10, 25, 50, 100, 200],
      },
    };
  },
  methods: {
    open_penalizare(row) {
      this.$refs.dlg_penalizare.open(row);
    },
    async print_consimtamant(id_deviz) {
      let isDev = '';
      if (LocalSettings.IS_DEV) { isDev = '/dev' }
      
      window.open(isDev + "/#/deviz_consimtamant_pdf/" + id_deviz, '_blank');
    },

    formatDate(value) {
      if (!value) return '';
      const d = new Date(value);
      const z = n => (n < 10 ? '0' + n : n);
      return `${z(d.getDate())}.${z(d.getMonth() + 1)}.${d.getFullYear()} ${z(d.getHours())}:${z(d.getMinutes())}`;
    },

    async adauga_programarea(masina_selectata_client) {

      masina_selectata_client.Id = masina_selectata_client.IdMasina;

      let client = { "Id": masina_selectata_client.IdClient };

      this.$refs.dlg_rez.programeaza_client(client, masina_selectata_client);

      this.showPopupProgramareNoua = false;

    },

    async marcaChangeHandler() {
      if (!this.Filters.Marca || this.Filters.Marca == '-1') {
        this.Info.modele = [];
        this.Filters.Model = '-1';
      }
      if (this.Filters.Marca) {
        const response = await this.post("receptie/rezervari/get_model_for_marca", { id_marca: this.Filters.Marca });
        if (response && response.modele) {
          this.Info.modele = response.modele;
        } else {
          this.Info.modele = [];
          this.Filters.Model = '';
        }
      }

      await this.refresh_info();
    },

    async preview(id) {
      this.$refs.preview_deviz.show(id)
    },

    print_inspectie(id_deviz) {
      // window.open("/#/inspectie_finala/" + id_deviz, '_blank');
      let isDev = '';
      if (LocalSettings.IS_DEV) { isDev = '/dev' }
      
      window.open(isDev + "/#/inspectie_finala/" + id_deviz, '_blank');

    },

    print_deviz(id_deviz) {
      let isDev = '';
      if (LocalSettings.IS_DEV) { isDev = '/dev' }


      window.open(isDev + "/#/deviz_produse_pdf/" + id_deviz, '_blank');
    },

    async get_info() {
      var response = await this.post("receptie/devize/get_info");
      this.Info.clienti = response.clienti;
      this.Info.marci = response.marci;
      // if (this.Filters.IdClient.length > 0)
      //   this.Filters.IdClient = this.Info.clienti[0].Id;
      this.refresh_info();
    },

    async refresh_info() {
      var response = await this.post("receptie/devize/get_devize_finalizate", {
        Filters: this.Filters,
        OrderBy: this.OrderBy,
        PaginationInfo: this.PaginationInfo,
      });
      this.Results = response.Results;
      this.PaginationInfo = response.PaginationInfo;
      //
      this.select_menu_item("devize_finalizate");
    },
    reset() {
      this.Filters = {
        Data: [],
        Numar: "",
        Marca: "-1",
        Model: "-1",
        TipAuto: "-1",
        Client: "",
        IdDeviz: "",
        IdCentruProductie: "-1",
        IdServiciuProgramator: "-1",
        Antifurt: "-1",
        ValoareMin: "",
        ValoareMax: "",
      };
      this.refresh_info();
    },

  },
  created() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.device = "phone"
    } else this.device = "computer"
  },
  mounted() {
    // if (!this.$has_right("Management")) {
    //   this.$router.push("/no-rights");
    //   return;
    // }
    this.base_url = settings.BASE_URL;
    this.get_info();
  },
};
</script>

<style lang="less" scoped>
.top50 {
  margin-top: 20px;
}

.filtre {
  .el-input-number {
    width: 100% !important;
  }
}



.input-element {
  width: 14%;
  margin-right: 2%;
}

@media only screen and (max-width: 600px) {
  .input-element {
    width: 80%;
  }

  .el-tooltip__popper {
    width: 90%;
  }

  .phone-btn {
    padding-left: 20px;
    position: -webkit-sticky;
    position: sticky;
    top: 0;
  }

  .el-date-editor--daterange.el-input__inner {
    width: 300px;
  }

  .el-picker-panel__body {
    display: flex;
    flex-direction: column;
  }
}
</style>
